import moment from "moment-timezone";

const generateCustomDate = (timezone, index) => {
  const timezoneval = moment().utcOffset(timezone).format('Z');

  // Guess the timezone name based on the current time and offset
  const guessedTimezone = moment.tz.guess(true);
  const d = moment().tz(guessedTimezone);
  d.day(index + d.day());
  return d;
};

const getDayFromDate = (timezone, index) => {
  // OWM time(dt) is meaningless
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const date = generateCustomDate(timezone, index);
  return days[date.day()];
};

export { getDayFromDate, generateCustomDate };
